export default "__VITE_ASSET__BsyUJTZU__"